import React, { useState, useEffect, Component, useRef ,useContext} from "react";
import { ShiftListPage } from "./ShiftListPage";
import { ShiftService } from "../../api/ShiftService";
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { AuthService } from "../../api/AuthService";
import {
  Tabs,
  Tab,
  makeStyles,
  createStyles,
  IconButton,
  Paper,
  Typography,
  Icon,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Popover,
  Menu,
  MenuItem,
  ListItemText,
} from "@material-ui/core";
import { getEffectiveRoleName, roleNameEnum } from "../../util/Common";
import { ShiftRelatedConstants } from "../../util/ShiftConstants";
import { Colors, Spacing } from "../../theme/Theme";
import { RBAppbar } from "../../components/RBAppbar";
import moment from "moment";
import TuneIcon from "@material-ui/icons/Tune";
import FilterListIcon from "@material-ui/icons/FilterList";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CheckIcon from "@material-ui/icons/Check";
import SortIcon from "@material-ui/icons/Sort";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import FormatListBulletted from "@material-ui/icons/FormatListBulleted";
import CalendarToday from "@material-ui/icons/CalendarToday";
import CalendarTodayOutlined from "@material-ui/icons/CalendarTodayOutlined";
import CalendarViewDayOutlined from "@material-ui/icons/CalendarViewDayOutlined";
import {ReactComponent as CalendarIconSvg} from '../../img/CalendarMonthViewGrey.svg';
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { RBModal } from "../../components/RBModal";
import { RBCardView } from "../../components/RBCardView";
import { RBCalendar } from "../../components/RBCalendar";
import { RBContext } from "../../components/RBContext";
import { CalendarViewDayTwoTone } from "@material-ui/icons";
import { IndustryModeEnum } from "../../api/constants";
import { useHistory, useLocation } from "react-router-dom";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { shouldShowShiftRatingWhileAwaitingHours } from "../../util/shiftRating";
import {
  ShiftListRouteState,
  ShiftListUiState,
  ShiftStatusFilter,
} from "../../util/shiftListUiState";
import { AccountInfoContext } from "../../components/AccountInfoContext";

interface ShiftListControllerProps {}

type ShiftStatusFilterKey = keyof ShiftStatusFilter;

const defaultPastShiftStatusFilter: ShiftStatusFilter = {
  awaitingConfirmation: true,
  requestToCancel: true,
  readyForShift: true,
  activeShift: true,
  dispute: true,
  cancelled: true,
  shiftCompleted: true,
  rateShift: true,
  paid: true,
  unpaid: true,
};

const defaultAcceptedShiftStatusFilter: ShiftStatusFilter = {
  awaitingConfirmation: true,
  requestToCancel: true,
  readyForShift: true,
  activeShift: true,
  dispute: true,
  cancelled: false,
  shiftCompleted: false,
  rateShift: false,
  paid: false,
  unpaid: false,
};

const baseShiftStatusFilterOptions: Array<{
  key: Exclude<ShiftStatusFilterKey, "paid" | "unpaid">;
  label: string;
}> = [
  { key: "awaitingConfirmation", label: "Awaiting Confirmation" },
  { key: "requestToCancel", label: "Request to Cancel" },
  { key: "readyForShift", label: "Ready For Shift" },
  { key: "activeShift", label: "Active Shift" },
  { key: "dispute", label: "In Dispute" },
  { key: "cancelled", label: "Cancelled" },
  { key: "shiftCompleted", label: "Shift Completed" },
  { key: "rateShift", label: "Rate Shift" },
];

const paymentShiftStatusFilterOptions: Array<{
  key: Extract<ShiftStatusFilterKey, "paid" | "unpaid">;
  label: string;
}> = [
  { key: "paid", label: "Paid" },
  { key: "unpaid", label: "Unpaid" },
];

const normalizeShiftStatusFilter = (
  filter: ShiftStatusFilter | null | undefined,
  defaults: ShiftStatusFilter
): ShiftStatusFilter => ({
  ...defaults,
  ...(filter ?? {}),
});

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textTransform: "none",
      // color: Colors.black,
      "&:hover": {
        color: Colors.themeBlue,
        opacity: 1,
      },
      "&$selected": {
        color: Colors.black,
        fontWeight: "600",
      },
      "&:focus": {
        color: Colors.black,
      },
    },
    selected: {
      //color: Colors.themeBlue,
    },
    indicator: {
      backgroundColor: Colors.black,
    },
  })
);

enum ShiftStateForPharmacy {
  Active = "Active",
  Past = "Past",
  Applicants = "Applicants"
}
enum ShiftStateForWorker {
  Accepted = "Accepted",
  Past = "Past",
  Request = "Applied",
}
export const ShiftListController: React.FC<ShiftListControllerProps> = ({
  ...props
}) => {
  const history = useHistory();
  const location = useLocation<ShiftListRouteState>();
  const persistedShiftListUiState = location.state?.shiftListUiState ?? null;
  const persistedShiftState = persistedShiftListUiState?.shiftState;
  const storedShiftState = Number(localStorage.getItem("ShiftState"));
  const initialShiftState =
    typeof persistedShiftState === "number" && Number.isFinite(persistedShiftState)
      ? persistedShiftState
      : Number.isFinite(storedShiftState)
      ? storedShiftState
      : 0;
  const initialViewOption =
    persistedShiftListUiState?.viewOption === "Calendar" ? "Calendar" : "List";
  const initialActiveCalendarDate = (() => {
    const storedDate = persistedShiftListUiState?.activeCalendarDate;
    if (!storedDate) {
      return new Date();
    }

    const parsedDate = new Date(storedDate);
    return Number.isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
  })();
  const [shifts, setShifts] = useState<ShiftProps[]>([]);
  const [applicants, setApplicants] = useState([]);
  const [calendarShifts, setCalendarShifts] = useState<ShiftProps[]>([]);
  const [refresh, setRefetch] = useState(false);
  const [roleName] = useState<string>(AuthService.getRoleName());
  const [shiftState, setShiftState] = useState(initialShiftState);
  const [effectiveRoleName, setEffectiveRoleName] = useState<string>(roleName);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [openTuneSetting, setOpenTuneSetting] = useState(false);
  const [openShiftFilterDropdown, setOpenShiftFilterDropdown] = useState(false);
  const [sortOrder, setSortOrder] = useState<"desc" | "asc">(
    persistedShiftListUiState?.sortOrder === "desc" ||
      persistedShiftListUiState?.sortOrder === "asc"
      ? persistedShiftListUiState.sortOrder
      : roleName === roleNameEnum.pharmacist && initialShiftState !== 0
      ? "desc"
      : "asc"
  );
  const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
  const anchorFilterRef = React.useRef<HTMLButtonElement>(null);
  const anchorTuneRef = React.useRef<HTMLButtonElement>(null);
  const [showAllShifts, setShowAllShifts] = useState(false);
  const didMountRef = useRef(false);
  const firstFetchRef = useRef(true);
  const [pharmacy, setPharmacyInfo] = useState<any>([]);
  const [viewOption, setViewOption] = useState<"List" | "Calendar">(initialViewOption);
  const [listShifts, setListShifts] = useState<ShiftProps[]>([]);
  const [activeCalendarDate, setActiveCalendarDate] = useState<Date>(initialActiveCalendarDate);
  const [userId, setUserId] = useState<string>("");
  const [accountNetworkDoesNotPay, setAccountNetworkDoesNotPay] = useState(false);
  const [acceptedShiftStatusFilter, setAcceptedShiftStatusFilter] = useState<ShiftStatusFilter>(
    normalizeShiftStatusFilter(
      persistedShiftListUiState?.acceptedShiftStatusFilter,
      defaultAcceptedShiftStatusFilter
    )
  );
  const [pastShiftStatusFilter, setPastShiftStatusFilter] = useState<ShiftStatusFilter>(
    normalizeShiftStatusFilter(
      persistedShiftListUiState?.pastShiftStatusFilter,
      defaultPastShiftStatusFilter
    )
  );
  const lastFilterTabRef = useRef<0 | 1>(0);
  const { industryMode,primaryColor,secondaryColor,updateprimaryColor,updateSecondaryColor,updateContactEmail,updateContactPhone,updateMode  } = useContext(RBContext);
  const isRegionalManager = roleName === roleNameEnum.regionalmanager;
  const { accountInformation } = useContext(AccountInfoContext);
  
  
  const isOwnerLike =
    effectiveRoleName === roleNameEnum.owner ||
    roleName === roleNameEnum.regionalmanager;
  const isPharmacist = roleName === roleNameEnum.pharmacist;
  const isOwnerApplicantsTab =
    roleName === roleNameEnum.owner && shiftState === 2;
  const isShiftStatusFilterApplicable =
    isPharmacist && (shiftState === 0 || shiftState === 1);
  const activeFilterTab: 0 | 1 =
    shiftState === 1 ? 1 : shiftState === 0 ? 0 : lastFilterTabRef.current;
  const safeAcceptedShiftStatusFilter =
    normalizeShiftStatusFilter(
      acceptedShiftStatusFilter,
      defaultAcceptedShiftStatusFilter
    );
  const safePastShiftStatusFilter =
    normalizeShiftStatusFilter(
      pastShiftStatusFilter,
      defaultPastShiftStatusFilter
    );
  const activeShiftStatusFilter =
    activeFilterTab === 1
      ? safePastShiftStatusFilter
      : safeAcceptedShiftStatusFilter;
  const activeDefaultShiftStatusFilter =
    activeFilterTab === 1
      ? defaultPastShiftStatusFilter
      : defaultAcceptedShiftStatusFilter;

  const isShiftFilterActive =
    isPharmacist &&
    (Object.keys(activeDefaultShiftStatusFilter) as Array<keyof ShiftStatusFilter>).some(
      (key) => activeShiftStatusFilter[key] !== activeDefaultShiftStatusFilter[key]
    );

  const updateActiveShiftStatusFilter = (
    updater: (previous: ShiftStatusFilter) => ShiftStatusFilter
  ) => {
    if (activeFilterTab === 1) {
      setPastShiftStatusFilter((prev) =>
        updater(
          normalizeShiftStatusFilter(prev, defaultPastShiftStatusFilter)
        )
      );
    } else {
      setAcceptedShiftStatusFilter((prev) =>
        updater(
          normalizeShiftStatusFilter(prev, defaultAcceptedShiftStatusFilter)
        )
      );
    }
  };

  const handleActiveShiftStatusFilterChange = (
    key: ShiftStatusFilterKey,
    checked: boolean
  ) => {
    updateActiveShiftStatusFilter((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const getFilteredShifts = (sourceShifts: ShiftProps[]) => {
    if (!isShiftStatusFilterApplicable) {
      return sourceShifts;
    }

    const tabFilter =
      shiftState === 1
        ? safePastShiftStatusFilter
        : safeAcceptedShiftStatusFilter;

    const matchesPaymentFilter = (shift: ShiftProps) => {
      const shiftNetworkPaid =
        typeof shift.networkPaid !== "undefined"
          ? shift.networkPaid
          : shift?.pharmacy?.networkPaid;
      const isNetworkPaid = !!shiftNetworkPaid;

      if (isNetworkPaid) {
        return false;
      }

      const isPaid = !!(shift as any)?.paymentData;
      if (isPaid && tabFilter.paid) {
        return true;
      }
      if (!isPaid && tabFilter.unpaid) {
        return true;
      }

      return false;
    };

    const matchesCompletedStatusFilter = () =>
      tabFilter.shiftCompleted || tabFilter.rateShift;

    return sourceShifts.filter((shift: ShiftProps) => {
      const matchesAwaitingAndRateShift = shouldShowShiftRatingWhileAwaitingHours(
        shift,
        industryMode,
        roleName
      );
      const isCompletionAcknowledged =
        shift?.flags?.isCompletionAcknowledged === true;

      if (matchesAwaitingAndRateShift) {
        if (isCompletionAcknowledged) {
          return (
            matchesPaymentFilter(shift) ||
            matchesCompletedStatusFilter()
          );
        }

        return (
          tabFilter.awaitingConfirmation ||
          tabFilter.rateShift
        );
      }

      const status = ShiftService.getStatusForShiftAsWorker(
        shift,
        roleName,
        industryMode
      );
      if (
        status ===
        ShiftRelatedConstants.ShiftStateText.AwaitingWorkerConfirmation
      ) {
        return tabFilter.awaitingConfirmation;
      }
      if (
        status ===
        ShiftRelatedConstants.ShiftStateText.AwaitingHoursConfirmation
      ) {
        return tabFilter.awaitingConfirmation;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.ReadyForShiftReqCancel) {
        return tabFilter.requestToCancel;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.ReadyForShift) {
        return tabFilter.readyForShift;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.ActiveShift) {
        return tabFilter.activeShift;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.InDispute) {
        return tabFilter.dispute;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.Cancelled) {
        return tabFilter.cancelled;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.ShiftCompleted) {
        if (matchesPaymentFilter(shift)) {
          return true;
        }

        return tabFilter.shiftCompleted;
      }
      if (status === ShiftRelatedConstants.ShiftStateText.RateShift) {
        if (matchesPaymentFilter(shift)) {
          return true;
        }

        return isCompletionAcknowledged
          ? matchesCompletedStatusFilter()
          : tabFilter.rateShift;
      }
      return true;
    });
  };

  const filteredShifts = getFilteredShifts(shifts);
  const getShiftsForDate = (sourceShifts: ShiftProps[], activeDate: Date) => {
    return sourceShifts.filter(
      (shift) =>
        moment(shift.startTime).format("YYYY-MM-DD") ===
        moment(activeDate).format("YYYY-MM-DD")
    );
  };
  const canShowPaidUnpaidFilterOptions =
    isPharmacist && accountNetworkDoesNotPay;
  const sortParam = sortOrder === "desc" ? "-startTime" : "startTime";

  const onShiftChanged = (data: string) => {
    console.log("onShiftChanged", data);
    setRefetch((pre) => !pre);
  };

  const fetchData = async () => {
    const userData = accountInformation;
    if (!accountInformation) return;

    const nextEffectiveRoleName = getEffectiveRoleName(userData, roleName);
    setEffectiveRoleName(nextEffectiveRoleName);
    const selectedPharmacyId =
      localStorage.getItem("regionalManagerSelectedLocationId") ||
      userData?.owner?.defaultPharmacyId;
    const selectedOwnerId =
      localStorage.getItem("regionalManagerSelectedUserId") ||
      userData?.pharmacies?.find((item: any) => item.id === selectedPharmacyId)?.owner?.id;
    const regionalManagerFilters =
      isRegionalManager && selectedPharmacyId && selectedOwnerId
        ? {
            pharmacyId: selectedPharmacyId,
            ownerId: selectedOwnerId,
          }
        : {};
    const networkDoesNotPay =
      userData?.networks?.some(
        (network: any) => network?.paymentConfig?.networkPays === false
      ) === true;
    setAccountNetworkDoesNotPay(networkDoesNotPay);

    setUserId(userData?.id);
    console.log("@@userId in shift list", userId);
    
    console.log("@@userData in shift list", userData.id);
   
    // setIsPageLoading(true);
    if (firstFetchRef.current) {
      setIsPageLoading(true);
   }
    if (nextEffectiveRoleName === roleNameEnum.owner) {
      const defaultPharmacyId = userData.owner.defaultPharmacyId;
      const indexOfDefaultPharmacy = userData.pharmacies.findIndex((obj: ObjectLiteral) => obj.id == defaultPharmacyId)
      console.log('indexOfDefaultPharmacy', indexOfDefaultPharmacy)
      const pharmacy = userData.pharmacies[indexOfDefaultPharmacy ?? 0];
      console.log('pharmacy selected ', pharmacy);
      setPharmacyInfo(pharmacy);
      console.log("shiftState11",shiftState)
      switch (shiftState) {
        case 0: {
          //pharmacy upComing
          const shiftListData = await ShiftService.getShiftListForOwner({
            byPriority: true,
            showAllShifts,
            limit: 2000,
            networkId:pharmacy.networkId,
            ...regionalManagerFilters,
          });
          setShifts(
            shiftListData.data.filter((shift: any) => {
              const actionNeededStates = [
                ShiftRelatedConstants.ShiftStateText.AwaitingHiring,
                ShiftRelatedConstants.ShiftStateText.ReadyForShift,
                ShiftRelatedConstants.ShiftStateText.ActiveShift,
                ShiftRelatedConstants.ShiftStateText.AwaitingWorkerConfirmation,
                ShiftRelatedConstants.ShiftStateText.AwaitingHoursConfirmation,
                ShiftRelatedConstants.ShiftStateText.InDispute,
                ShiftRelatedConstants.ShiftStateText.ReadyForShiftReqCancel,
                //ShiftRelatedConstants.ShiftStateText.RateShift,
              ];
              if (shift.completionAcknowledgedAt && shift.pharmacy?.ratingOptionTimer) {
                let currentTime = moment().utc();
                let completionAcknowledgedAt = moment(shift.completionAcknowledgedAt).utc().add(shift.pharmacy.ratingOptionTimer, 'minutes');

                if (currentTime.isBefore(completionAcknowledgedAt)) {

                  actionNeededStates.push(ShiftRelatedConstants.ShiftStateText.RateShift);
                  actionNeededStates.push(ShiftRelatedConstants.ShiftStateText.FeedbackShift);

                  // if (shift.pharmacy?.networkPaid === false && shift?.locationAutoAcknowledged && shift?.locationAutoAcknowledged === true) {
                  //   actionNeededStates.push(ShiftRelatedConstants.ShiftStateText.FeedbackShift);
                  // }
                  // if (shift.pharmacy.networkPaid === true) {
                  //   actionNeededStates.push(ShiftRelatedConstants.ShiftStateText.RateShift);
                  // }
                }

              }

              return actionNeededStates.includes(
                ShiftService.getStatusForShiftAsPharmacy(shift,effectiveRoleName,industryMode)
              );
            })
          );
          break;
        }
        case 1: {
          //pharmacy
          const shiftListData = await ShiftService.getShiftListForOwner({
            limit: 2000,
            showAllShifts,
            sort: ["-startTime"],
            networkId:pharmacy.networkId,
            ...regionalManagerFilters,
          });
          setShifts(
            shiftListData.data
              .filter((shift: any) => {
                const noActionNeededStates = [
                  ShiftRelatedConstants.ShiftStateText.ShiftExpired,
                  ShiftRelatedConstants.ShiftStateText.Cancelled,
                  ShiftRelatedConstants.ShiftStateText.ShiftCompleted,
                ];
                if(shift.completionAcknowledgedAt && shift.pharmacy?.ratingOptionTimer)
                {
                  let currentTime = moment().utc();
                  let completionAcknowledgedAt = moment(shift.completionAcknowledgedAt).utc().add(shift.pharmacy.ratingOptionTimer, 'minutes');
                  if(currentTime.isAfter(completionAcknowledgedAt)){
                    
                    noActionNeededStates.push(ShiftRelatedConstants.ShiftStateText.RateShift);
                    noActionNeededStates.push(ShiftRelatedConstants.ShiftStateText.FeedbackShift);
                    // if(shift.pharmacy?.networkPaid === false && shift?.locationAutoAcknowledged && shift?.locationAutoAcknowledged === true)
                    // {
                    //   noActionNeededStates.push(ShiftRelatedConstants.ShiftStateText.FeedbackShift);
                    // }
                    // if(shift.pharmacy?.networkPaid === true){
                    //   noActionNeededStates.push(ShiftRelatedConstants.ShiftStateText.RateShift);
                    // }
                  }
                }
                return noActionNeededStates.includes(
                  ShiftService.getStatusForShiftAsPharmacy(shift,effectiveRoleName,industryMode)
                );
              })
              .sort(
                (shift1: any, shift2: any) =>
                  moment.utc(shift2.startTime).unix() -
                  moment.utc(shift1.startTime).unix()
              )
          );
          break;
        }
        case 2: {
          console.log("shiftState12",shiftState)
          const shiftListData = await ShiftService.getApplicantsByPharmacyId(
            pharmacy.id
          );
          setApplicants(shiftListData.data);
          break;
        }
      }
      console.log('list',shifts)
      setShowAllShifts(
        localStorage.getItem("showAllShifts")
          ? localStorage.getItem("showAllShifts") === "Yes"
          : false
      );
    }
    if (nextEffectiveRoleName === roleNameEnum.pharmacist) {
      let data = [];
      switch (shiftState) {
        case 0: {
          // worker accepted
          const shiftListData = await ShiftService.getShiftListForWorker({
            limit: 1000,
            sort: [sortParam],
            state: "worker-accepted",
            networkId: userData.networks[0].id,
          });
          let newData = shiftListData.data;
          console.log('shifts data coming from backend', shiftListData.data)
          if (viewOption === "List") {
            const oldTime = moment().subtract(3, "days");
            newData = newData.filter((shift: any) => {
              return !(
                shift.flags &&
                ((shift.completionAcknowledgedAt &&
                  moment(shift.completionAcknowledgedAt) < oldTime) ||
                  shift.flags.isCancelled) &&
                moment(shift.startTime) < oldTime
              );
            });
          }

          setShifts(
            newData.filter((shift: any) => {
              if (!shift.networkPaid) {
                if (
                  shift.completionAcknowledgedAt &&
                  shift?.workerAutoAcknowledged &&
                  shift?.workerAutoAcknowledged === true &&
                  shift.pharmacy?.ratingOptionTimer
                ) {
                  let currentTime = moment().utc();
                  let completionAcknowledgedAt = moment(
                    shift.completionAcknowledgedAt
                  )
                    .utc()
                    .add(shift.pharmacy.ratingOptionTimer, "minutes");
                  if (currentTime.isBefore(completionAcknowledgedAt)) {
                    return shift.flags && shift.flags.isAssigned;
                  } else {
                    return false;
                  }
                }
              }

              return shift.flags && shift.flags.isAssigned;
            })
          );
          

          break;
        }
        case 1: {
          // worker past
          const shiftListData = await ShiftService.getShiftListForWorker({
            limit: 1000,
            sort: [sortParam],
            state: "worker-past",
            networkId: userData.networks[0].id,
          });

          setShifts(shiftListData.data);


          break;
        }
        case 2: {
          // worker applied
          const shiftListData = await ShiftService.getShiftListForWorker({
            limit: 1000,
            sort: [sortParam],
            state: "requested",
            networkId: userData.networks[0].id,
          });
          let newData = shiftListData.data;
          if (viewOption === "List") {
            const oldTime = moment().subtract(3, "days");
            newData = newData.filter((shift: any) => {
              return !(
                shift.flags &&
                ((shift.completionAcknowledgedAt &&
                  moment(shift.completionAcknowledgedAt) < oldTime) ||
                  shift.flags.isCancelled) &&
                moment(shift.startTime) < oldTime
              );
            });
          }

          setShifts(
            newData.filter((shift: any) => {
              return !(shift.flags && shift.flags.isAssigned);
            })
          );

          break;
        }
      }
    }
    setIsPageLoading(false);
    // subsequent fetches should not show full-page loader
    firstFetchRef.current = false;
  };
  useEffect(() => {
    (async () => {
        await updateprimaryColor( localStorage.getItem('primaryColor')); 
        await updateSecondaryColor( localStorage.getItem('secondaryColor')); 
        await updateContactEmail( localStorage.getItem('contactEmail')); 
        await updateContactPhone( localStorage.getItem('contactPhone')); 
        await updateMode(localStorage.getItem('industryMode')); 
        
    })();
    
    const unsub = NotificationService.subscribe(
      NotificationServiceTopic.ShiftChanged,
      onShiftChanged
    );
    
    fetchData();

    return () => {
      console.log("shift list controller clean up");
      unsub.unsubscribe();
    };
  }, [shiftState, refresh, sortOrder]);

  useEffect(() => {
    if (shiftState === 0 || shiftState === 1) {
      lastFilterTabRef.current = shiftState;
    }
  }, [shiftState]);
  useEffect(() => {
    if (!isShiftStatusFilterApplicable && openShiftFilterDropdown) {
      setOpenShiftFilterDropdown(false);
    }
  }, [isShiftStatusFilterApplicable, openShiftFilterDropdown]);
  useEffect(() => {
    if (viewOption !== 'List' && sortAnchorEl) {
      setSortAnchorEl(null);
    }
  }, [viewOption, sortAnchorEl]);
  useEffect(() => {
    const nextShiftListUiState: ShiftListUiState = {
      shiftState,
      sortOrder,
      viewOption,
      activeCalendarDate: activeCalendarDate.toISOString(),
      acceptedShiftStatusFilter: safeAcceptedShiftStatusFilter,
      pastShiftStatusFilter: safePastShiftStatusFilter,
    };
    const previousShiftListUiState = location.state?.shiftListUiState ?? null;

    if (
      JSON.stringify(previousShiftListUiState) ===
      JSON.stringify(nextShiftListUiState)
    ) {
      return;
    }

    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: {
        ...(location.state ?? {}),
        shiftListUiState: nextShiftListUiState,
      },
    });
  }, [
    history,
    location.hash,
    location.pathname,
    location.search,
    shiftState,
    sortOrder,
    viewOption,
    activeCalendarDate,
    safeAcceptedShiftStatusFilter,
    safePastShiftStatusFilter,
  ]);
  useEffect(() => {
    console.log("worker shift",shifts)
    const currentFilteredShifts = getFilteredShifts(shifts);
    if (viewOption === 'Calendar') {
      setCalendarShifts(getShiftsForDate(currentFilteredShifts, activeCalendarDate));
      return;
    }
    setCalendarShifts(currentFilteredShifts);
  }, [shifts, acceptedShiftStatusFilter, pastShiftStatusFilter, shiftState, viewOption, activeCalendarDate]);
  useEffect(() => {
    if (didMountRef.current) {
      console.log("showAllShifts changed for shift list", showAllShifts);
      localStorage.setItem("showAllShifts", showAllShifts ? "Yes" : "No");
      fetchData();
    } else {
      didMountRef.current = true;
    }
  }, [showAllShifts, viewOption]);
  useEffect(() => {
    if (
      !canShowPaidUnpaidFilterOptions &&
      (
        !safeAcceptedShiftStatusFilter.paid ||
        !safeAcceptedShiftStatusFilter.unpaid ||
        !safePastShiftStatusFilter.paid ||
        !safePastShiftStatusFilter.unpaid
      )
    ) {
      setAcceptedShiftStatusFilter((prev) => ({
        ...(prev ?? defaultAcceptedShiftStatusFilter),
        paid: defaultAcceptedShiftStatusFilter.paid,
        unpaid: defaultAcceptedShiftStatusFilter.unpaid,
      }));
      setPastShiftStatusFilter((prev) => ({
        ...(prev ?? defaultPastShiftStatusFilter),
        paid: defaultPastShiftStatusFilter.paid,
        unpaid: defaultPastShiftStatusFilter.unpaid,
      }));
    }
  }, [
    canShowPaidUnpaidFilterOptions,
    safeAcceptedShiftStatusFilter.paid,
    safeAcceptedShiftStatusFilter.unpaid,
    safePastShiftStatusFilter.paid,
    safePastShiftStatusFilter.unpaid,
  ]);

  // Fetch Associated Data if the Account Information becomes available or changes.
  useEffect(() => {
    fetchData();
  }, [accountInformation]);

  const handleShiftStateChange = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setIsPageLoading(true);
    if (roleName === roleNameEnum.pharmacist) {
      setSortOrder(newValue === 0 ? "asc" : "desc");
    }
    setShiftState(newValue);
    localStorage.setItem('ShiftState',newValue.toString())
  };
  const classes = useStyles();
  const renderAppBar = () => {
    // const pharmacyName = AuthService.getOwnerAccountInfo();
    // console.log('ownerAccountInfo', pharmacy)
    const allOfficeText = industryMode === IndustryModeEnum.Dentistry ?
                          'Dental Practices' :
                          industryMode === IndustryModeEnum.Pharmaceutical?
                          'Pharmacies':
                          'Companies';
    console.log('showAllShift', showAllShifts)
    console.log("shiftState",shiftState)
    return (
      <>
        <RBAppbar
          searchable={false}
          barName={isOwnerLike
            ? showAllShifts 
            ? 'All Locations' 
            : pharmacy.name 
            : 'Schedule'}
          barChildren={
            <>
              <Tabs
                value={shiftState}
                onChange={handleShiftStateChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                classes={{ indicator: classes.indicator }}
                style={{
                  marginRight: Spacing.small,
                }}
              >
                <Tab
                  classes={{
                    root: classes.root,
                    selected: classes.selected,
                  }}
                  label={
                    isOwnerLike
                      ? ShiftStateForPharmacy.Active
                      : ShiftStateForWorker.Accepted
                  }
                />
                <Tab
                  classes={{
                    root: classes.root,
                    selected: classes.selected,
                  }}
                  label={
                    isOwnerLike
                      ? ShiftStateForPharmacy.Past
                      : ShiftStateForWorker.Past
                  }
                />
                {roleName === roleNameEnum.pharmacist &&
                <Tab
                  classes={{
                    root: classes.root,
                    selected: classes.selected,
                  }}
                  label={ShiftStateForWorker.Request}
                />}
                {isOwnerLike &&
                <Tab
                  classes={{
                    root: classes.root,
                    selected: classes.selected,
                  }}
                  label={ShiftStateForPharmacy.Applicants
                  }
                />}
              </Tabs>
              {isShiftStatusFilterApplicable && (
                <IconButton
                  style={{ color: primaryColor }}
                  title={isShiftFilterActive ? "Filter On" : "Filter Off"}
                  onClick={() =>
                    setOpenShiftFilterDropdown((prevOpen) => !prevOpen)
                  }
                  ref={anchorFilterRef}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FilterListIcon
                      style={{
                        color: isShiftFilterActive
                          ? secondaryColor
                          : Colors.darkGrey,
                      }}
                    />
                    {isShiftFilterActive && (
                      <CheckCircleIcon
                        style={{
                          position: "absolute",
                          right: -6,
                          top: -6,
                          fontSize: 14,
                          color: Colors.themeGreen,
                          backgroundColor: Colors.white,
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </div>
                </IconButton>
              )}
              {isPharmacist && !isOwnerApplicantsTab && viewOption === 'List' && (
                <IconButton
                  style={{ color: sortOrder === "asc" ? secondaryColor : primaryColor }}
                  title={sortOrder === "asc" ? "Sort: Ascending" : "Sort: Descending"}
                  onClick={(event) => setSortAnchorEl(event.currentTarget)}
                >
                  <SortIcon />
                </IconButton>
              )}
              {/* {roleName === roleNameEnum.owner && ( */}
                {!isOwnerApplicantsTab &&
                <IconButton
                  style={{ color: primaryColor }}
                  onClick={() => setOpenTuneSetting((prevOpen) => !prevOpen)}
                  ref={anchorTuneRef}
                >
                  <TuneIcon />
                </IconButton>}
              {/* // )} */}
            </>
          }
        />
      </>
    );
  };

  const renderSortMenu = () => {
    return (
      <Menu
        anchorEl={sortAnchorEl}
        keepMounted
        open={Boolean(sortAnchorEl)}
        onClose={() => setSortAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setSortOrder("desc");
            setSortAnchorEl(null);
          }}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <ListItemText primary="Descending" />
          <div style={{ width: 24, display: "flex", justifyContent: "flex-end" }}>
            {sortOrder === "desc" ? <CheckIcon fontSize="small" /> : null}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortOrder("asc");
            setSortAnchorEl(null);
          }}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <ListItemText primary="Ascending" />
          <div style={{ width: 24, display: "flex", justifyContent: "flex-end" }}>
            {sortOrder === "asc" ? <CheckIcon fontSize="small" /> : null}
          </div>
        </MenuItem>
      </Menu>
    );
  };
  const renderTuneSettingContent = () => {
    const pharmacyName = AuthService.getOwnerAccountInfo().pharmacyName;
    return (
      <>
      <Paper style={{ margin: Spacing.medium }}>
        {isOwnerLike &&
          (<RBCardView
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              padding: Spacing.small,
            }}
            clickable={true}
            onClick={async () => {
              setOpenTuneSetting(false);

              setShowAllShifts((pre) => !pre);
            }}
          >
            <SwapHorizIcon fontSize={"large"} />
            <div style={{ paddingLeft: Spacing.larger }}>
              <Typography>
                {showAllShifts ? "View limited shifts" : "View all shifts"}
              </Typography>
              <Typography variant={"caption"}>
                {showAllShifts
                  ? `Select here to view: ${pharmacyName}`
                  : "Select here to view: Shifts for all"}
              </Typography>
            </div>
          </RBCardView>
          ) } 
        </Paper>
        <Paper style={{ margin: Spacing.medium }}>
          <RBCardView
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              padding: Spacing.small,
            }}
            // clickable={true}
            // onClick={async () => {
            //   setOpenTuneSetting(false);

            //   // setShowAllShifts((pre) => !pre);
            // }}
          >
            <div style={{ paddingLeft: Spacing.larger, flex: 1, textAlign: 'center' }}>
              <Typography>
                Shifts display as
              </Typography>
            </div>
            {renderViews()}
          </RBCardView>
      </Paper>
      </>
    );
  };

  const renderShiftFilterDropdown = () => {
    return (
      <Popover
        open={openShiftFilterDropdown}
        anchorEl={anchorFilterRef.current}
        onClose={() => setOpenShiftFilterDropdown(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div
          style={{
            padding: Spacing.medium,
            minWidth: 320,
          }}
        >
          <Typography
            style={{
              marginBottom: Spacing.small,
              fontWeight: 600,
            }}
          >
            Filter Shifts
          </Typography>
          <Typography variant="caption" style={{ marginBottom: Spacing.small }}>
            {activeFilterTab === 1 ? "Past tab" : "Accepted tab"}
          </Typography>
          <FormGroup>
            {baseShiftStatusFilterOptions.map(({ key, label }) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={Boolean(activeShiftStatusFilter[key])}
                    onChange={(_, checked) =>
                      handleActiveShiftStatusFilterChange(key, checked)
                    }
                    color="primary"
                  />
                }
                label={label}
              />
            ))}
            {canShowPaidUnpaidFilterOptions && (
              <>
                {paymentShiftStatusFilterOptions.map(({ key, label }) => (
                  <FormControlLabel
                    key={key}
                    control={
                      <Checkbox
                        checked={Boolean(activeShiftStatusFilter[key])}
                        onChange={(_, checked) =>
                          handleActiveShiftStatusFilterChange(key, checked)
                        }
                        color="primary"
                      />
                    }
                    label={label}
                  />
                ))}
              </>
            )}
          </FormGroup>
        </div>
      </Popover>
    );
  };

  const renderViews = () => {
    const anchorStyles = {
      cursor: 'pointer',
      // filter:`brightness(0) invert(1) saturate(100%) hue-rotate(${secondaryColor}deg)`,

    }

    return (
      <div style={{flex:1 , textAlign: 'center'}}>
        <a
          style={anchorStyles}
          onClick={() => {
            setViewOption('List');
            setOpenTuneSetting(false);
            // setShowAllShifts(() => true)
          }}
        >
          <FormatListBulletted
            style={{
              width: 35,
              height: 35,
              marginTop: 10,
              marginRight: 20,
              color: viewOption === 'List' ? 
                     secondaryColor : 
                     'grey'
            }}
          />
        </a>
        <a
           style={anchorStyles}
           onClick={() => {
            setActiveCalendarDate(new Date());
            setViewOption('Calendar');
            setOpenTuneSetting(false);
          }}
        >
       <CalendarIconSvg
          style={{
            width: 35,
            height: 35,
            marginTop: 10,
            marginRight: 20,
            fill: viewOption === 'Calendar'?
                  secondaryColor :
                  'grey'
          }}    
        />
        </a>
       
      </div>
    )
  }
  const renderTuneSetting = () => {
    // const pharmacyName = AuthService.getOwnerAccountInfo().pharmacyName;
    const allOfficeText = industryMode === IndustryModeEnum.Dentistry ?
                          'Dental Practices' :
                          industryMode === IndustryModeEnum.Pharmaceutical ?
                          'Pharmacies':
                          'Companies';
    return (
      <RBModal
        open={openTuneSetting}
        backDropEnabled={true}
        style={{ minHeight: 0, height: isOwnerLike ? 300 : 200}}
        onClose={() => setOpenTuneSetting((prevOpen) => !prevOpen)}
        modalTitle={isOwnerLike ?
          showAllShifts
            ? `Current display: All Locations`
            : `Current display: ${pharmacy.name}` :
            `Current filter: ${viewOption}`
        }
        children={renderTuneSettingContent()}
      />
    );
  };
  const scrollRestore = window.history.scrollRestoration;
  // console.log("scrollRestore", scrollRestore);

  const onActiveDayChanged = (activeDate: Date) => {
    setActiveCalendarDate(activeDate);
    setCalendarShifts(
      getShiftsForDate(filteredShifts, activeDate)
    );
    console.log(
      "calendarShifts ",
      calendarShifts.length,
      moment(activeDate).format("YYYY-MM-DD")
    );
  };
  return (
    <>
      {renderAppBar()}
      {isPharmacist && !isOwnerApplicantsTab && viewOption === 'List' && renderSortMenu()}
      {isShiftStatusFilterApplicable && renderShiftFilterDropdown()}
      {/* {roleName === roleNameEnum.owner && renderTuneSetting()} */}
      {renderTuneSetting()}
      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
          <>
          {viewOption === 'Calendar' && !isOwnerApplicantsTab && (
          <>
            <div style={{ margin: Spacing.large }}>
              <RBCalendar
                shifts={filteredShifts}
                onActiveDayChanged={onActiveDayChanged}
              />
            </div>
            <ShiftListPage
              shifts={calendarShifts}
              roleName={effectiveRoleName}
              userId={userId}
              shiftState={shiftState}
            />
          </>
          )}
          
          {viewOption === 'List' && !isOwnerApplicantsTab && (
          <ShiftListPage shifts={filteredShifts} roleName={effectiveRoleName}  userId={userId} shiftState={shiftState}/>
          )}
          {
            isOwnerApplicantsTab &&
            <ShiftListPage applicants={applicants} roleName={effectiveRoleName} pharmacy={pharmacy}/>
          }
        </>
      )}
    </>
  );
};
